import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getTeacherToken } from '../hooks/useTeacherAuth.js';
import { useRoomChannel } from '../deck/useRoomChannel.js';
import Deck from '../deck/Deck.jsx';

// The projected screen — what the class looks at. It is the presentation
// deck itself: the lesson's slides and its quiz questions on one linear
// track (see deck/Deck.jsx). The instructor's own screen is the control
// panel at /teacher/control/:roomId; both render the one position the
// server holds, so either can be opened first, or alone.
export default function TeacherHost() {
  const { roomId } = useParams();
  const navigate = useNavigate();
  const room = useRoomChannel(roomId);

  useEffect(() => {
    if (!getTeacherToken() || room.authState === 'unauthenticated') {
      navigate('/teacher', { replace: true });
    }
  }, [room.authState, navigate]);

  if (room.authState !== 'ok') {
    return (
      <div className="page">
        <p className="text-dim">กำลังตรวจสอบสิทธิ์...</p>
      </div>
    );
  }

  return <Deck room={room} onExit={() => navigate('/teacher')} />;
}
